import {ApiResponse, getApiService} from '@/services/api';
import {Gender, MaritalStatus} from '../types/personConstants.ts';
import { Person } from '../types/person.ts';

const PERSON_PATH = '/person';

export class PersonApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getAll() {
    const apiService = this.getApiInstance();
    return await apiService.client.get(PERSON_PATH);
  }

  static async getById(id: string) {
    const apiService = this.getApiInstance();
    return await apiService.client.get(`${PERSON_PATH}/${id}`);
  }

  static async create(data: Person): Promise<ApiResponse<Person>> {
    const apiService = this.getApiInstance();
    return await apiService.client.post(PERSON_PATH, data);
  }

  static async update(id: string, data: Person) {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${PERSON_PATH}/${id}`, data);
  }

  static async delete(id: string) {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${PERSON_PATH}/${id}`);
  }

  static async searchByFullName(fullName: string): Promise<ApiResponse<Person[]>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get<Person[]>(`${PERSON_PATH}/search`, { fullName });
  }
}
